function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "np_add-song_1248744_000000");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.247140067
}, React.createElement("g", {
  transform: "translate(-107.000000, -27.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(107.000000, 23.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 4.000000)"
}, React.createElement("path", {
  d: "M18.6815422,1.90278694 L12.2198611,0.0281244375 C12.1739971,0.0105466641 12.1255367,0.00175721486 12.0770763,0 C11.8218036,0 11.6149801,0.209176066 11.6149801,0.468440631 L11.6149801,10.5466641 C11.1693218,10.3919797 10.7020196,10.3128712 10.2303975,10.3119938 C8.44428586,10.3119938 7,11.3622728 7,12.6559969 C7,13.949721 8.44428586,15 10.2303975,15 C12.0165091,15 13.460795,13.949721 13.460795,12.6559969 L13.4616605,4.28368933 L18.4461581,5.624865 C18.4764461,5.62750172 18.5075981,5.62750172 18.5378861,5.624865 C18.6607684,5.624865 18.7775851,5.5747675 18.8641381,5.48687976 C18.9506734,5.39898977 19,5.28034064 19,5.15552889 L19,2.34308514 C18.9974039,2.14269965 18.8693308,1.9651602 18.681546,1.90276894 L18.6815422,1.90278694 Z"
}), React.createElement("polygon", {
  points: "9 5.41445004 9 3.61746945 5.39982721 3.61746945 5.39982721 0 3.60017279 0 3.60017279 3.61746945 0 3.61746945 0 5.41445004 3.60017279 5.41445004 3.60017279 9 5.39982721 9 5.39982721 5.41445004"
})))));

var SvgMusicIcon = function SvgMusicIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMusicIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/music-icon.5b6127fa.svg";
export { ForwardRef as ReactComponent };